import { useEffect, useMemo, useState } from 'react';

import { HeroSlide } from '../types/home';

const HERO_CAROUSEL_DELAY_MS = 4000; // 4 seconds per slide

const HERO_SLIDES: HeroSlide[] = [
  {
    id: 'slide-home-builders',
    backgroundImage: '/home-page-imagery/hero-home-builders.webp',
    backgroundAlt: 'Builder handing over new home to buyers with Help Genie',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-marine',
    backgroundImage: '/home-page-imagery/hero-marine.webp',
    backgroundAlt: 'Marina manager checking Help Genie on phone at golden hour dock',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-trades',
    backgroundImage: '/home-page-imagery/hero-trades.webp',
    backgroundAlt: 'Electrician using Help Genie at residential job site',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-appliances',
    backgroundImage: '/home-page-imagery/hero-appliances.webp',
    backgroundAlt: 'Appliance showroom representative using Help Genie on phone',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-manufacturing',
    backgroundImage: '/home-page-imagery/hero-manufacturing.webp',
    backgroundAlt: 'Factory supervisor using Help Genie on manufacturing floor',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-travel',
    backgroundImage: '/home-page-imagery/hero-travel.webp',
    backgroundAlt: 'Hotel concierge using Help Genie at boutique reception',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-real-estate',
    backgroundImage: '/home-page-imagery/hero-real-estate.webp',
    backgroundAlt: 'Real estate agent using Help Genie at open home viewing',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-industrial',
    backgroundImage: '/home-page-imagery/hero-industrial.webp',
    backgroundAlt: 'Safety manager using Help Genie at industrial facility',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-events',
    backgroundImage: '/home-page-imagery/hero-events.webp',
    backgroundAlt: 'Events coordinator using Help Genie backstage at venue',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-automotive',
    backgroundImage: '/home-page-imagery/hero-automotive.webp',
    backgroundAlt: 'Person learning about rental car features with Help Genie',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
  {
    id: 'slide-office-equipment',
    backgroundImage: '/home-page-imagery/hero-office-equipment.webp',
    backgroundAlt: 'Office worker scanning QR code on printer with Help Genie',
    fallbackBackground: '/hero-car-background.webp',
    phoneImage: '',
    phoneAlt: '',
  },
];

export const useHeroCarousel = (delayMs: number = HERO_CAROUSEL_DELAY_MS) => {
  const slides = useMemo(() => HERO_SLIDES, []);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return;
    }

    const timer = window.setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, delayMs);

    return () => {
      window.clearInterval(timer);
    };
  }, [delayMs, slides.length]);

  return {
    slides,
    currentIndex,
    currentSlide: slides[currentIndex],
    goToSlide: setCurrentIndex,
  };
};

